// AdminApprovalPage.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import A1 from '../Login/Chatbot.jpeg';

const AdminApprovalPage = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    axios.get('https://rvapi.emedha.in/auth/api/api/pending-users')
      .then(response => {
        setUsers(response.data);
      })
      .catch(error => {
        console.error('Error fetching pending users:', error);
      });
  }, []);

  const handleApprove = (email) => {
    axios.get(`https://rvapi.emedha.in/auth/api/admin/approve?email=${email}`)
      .then(() => {
        alert('User approved');
        setUsers(users.filter(user => user.email !== email)); 
      })
      .catch(error => {
        console.error('Error approving user:', error);
      });
  };


  const handleReject = (email) => {
    axios.get(`https://rvapi.emedha.in/auth/api/admin/reject?email=${email}`)
      .then(() => {
        alert('User rejected');
        setUsers(users.filter(user => user.email !== email));
      })
      .catch(error => {
        console.error('Error rejecting user:', error);
      });
  };

  return (
    <div className="container mt-5">
      <div className="text-center mb-4">
        <img src={A1} alt="ChatBot Services" style={{ width: '150px' }} />
        <h2 className="fw-bold text-primary">
          Emedha ChatBot <span className="text-success">Services</span>
        </h2>
        <p className="text-muted">Welcome back! 👋</p>
      </div>

      <div className="mb-4">
        <h3 className="text-center">PENDING USERS</h3>
        <div className="list-group">
          {users.map((user) => (
            <div className="list-group-item d-flex justify-content-between align-items-center" key={user.email}>
              <span>{user.email}</span>
              <div>
                <button className="btn btn-success btn-sm mx-2" onClick={() => handleApprove(user.email)}>
                  Approve
                </button>
                <button className="btn btn-danger btn-sm" onClick={() => handleReject(user.email)}>
                  Reject
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminApprovalPage;
